import { defineComponent } from "vue";
import data from "emoji-mart-vue-fast/data/all.json";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";

export default defineComponent({
    name: "EmojiPicker",
    components: { Picker },
    emits: ["emoji-selected"],

    props: {
        isHover: { type: Boolean, default: false }
    },

    data() {
        return {
            showPicker: false as boolean,
            selectedEmoji: "" as string,
            emojiIndex: new EmojiIndex(data),
            pickerPosition: "bottom" as "top" | "bottom"
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    methods: {
        togglePicker() {
            this.showPicker = !this.showPicker;

            if (this.showPicker) {
                this.$nextTick(() => {
                    this.calculatePosition();
                });
            }
        },

        calculatePosition() {
            const wrapper = this.$refs.emojiWrapper as HTMLElement;
            if (!wrapper) return;

            const rect = wrapper.getBoundingClientRect();
            const pickerHeight = 350; // approx emoji-mart height
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;

            this.pickerPosition = spaceBelow < pickerHeight && spaceAbove > pickerHeight ? "top" : "bottom";
        },

        onEmojiSelect(emoji: any) {
            this.selectedEmoji = emoji.native;
            this.$emit("emoji-selected", emoji.native);
            this.showPicker = false;
        },

        handleClickOutside(event: MouseEvent) {
            const wrapper = this.$refs.emojiWrapper as HTMLElement;
            if (!wrapper?.contains(event.target as Node)) {
                this.showPicker = false;
            }
        }
    }
});
